import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SentimentAnalysisComponent } from './sentiment-analysis.component';

const MODULES = [
  CommonModule,
  MatProgressBarModule
];

const COMPONENTS = [
  SentimentAnalysisComponent
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    SentimentAnalysisComponent
  ]
})
export class SentimentAnalysisModule { }
